import React from 'react'
import SarasTrans from '../../notifications/SarasTrans';
import SarasWrapper from '../../container/SarasWrapper';

const FormLabel = (props) => {
    const { formObject, action, rowKey, headerKey, customWrapper, wrapperClass, value } = props

    let viewData = formObject.getFormData(rowKey, headerKey, action.paramName);
    const hide = formObject.getValueFromKey(viewData, "dataList.isHid", "0");
    const label = formObject.getValueFromKey(viewData, "dataList.label", value);

    // console.log("view data", viewData);

    if(hide === "0"){
        return(
            <SarasWrapper customWrapper={customWrapper} wrapperClass={wrapperClass}>
                <SarasTrans value={label} />
            </SarasWrapper>
        )
    }

    return (null);
}

export default FormLabel